// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';
import {
  ListViewHeader as Header,
  ListViewPrimaryCell,
  ListViewSecondaryCell as SecondaryCell,
  ListViewSecondaryInformation as SecondaryInformation,
} from '../../internal/internal-typography';
import Container from '@material-ui/core/Table';
import MaterialTableRow, { TableRowProps } from '@material-ui/core/TableRow';
import Head from '@material-ui/core/TableHead';
import MaterialTableCell, { TableCellProps } from '@material-ui/core/TableCell';
import Body from '@material-ui/core/TableBody';
import Theme from './theme';
import type { DataProvidesProps } from '../../utils/constants';

const PRIMARY_CELL_CLASS_NAME = 'birch-table-primary-cell-typography';

type PrimaryCellProps = {
  children: Node,
  ...DataProvidesProps,
};

const PrimaryCell = ({ children, ...otherProps }: PrimaryCellProps) => (
  <ListViewPrimaryCell {...otherProps} className={PRIMARY_CELL_CLASS_NAME}>
    {children}
  </ListViewPrimaryCell>
);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const StyledRow = styled(MaterialTableRow)`
  ${({ hover }) =>
    hover &&
    `
      &&&:hover {
        background-color: ${Theme.hover.backgroundColor};
      }

      &&&:hover .${PRIMARY_CELL_CLASS_NAME} {
        text-decoration: underline;
      }

      &&&.MuiTableRow-head:hover {
        background: none;
      }
    `}
`;

type RowProps = {
  ...TableRowProps,
  ...DataProvidesProps,
};

const Row = ({ children, ...otherProps }: RowProps) => (
  <StyledRow hover {...otherProps}>
    {children}
  </StyledRow>
);

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const StyledTableCell = styled(MaterialTableCell)`
  &&&.MuiTableCell-head {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  &&&.MuiTableCell-root {
    padding-left: 8px;
    padding-right: 8px;

    &:first-child {
      padding-left: 4px;
    }
    &:last-child {
      padding-right: 4px;
    }
  }
`;

type CellProps = {
  ...TableCellProps,
  ...DataProvidesProps,
};

const Cell = ({ children, ...otherProps }: CellProps) => (
  <StyledTableCell {...otherProps}>{children}</StyledTableCell>
);

export default {
  Typography: {
    Header,
    PrimaryCell,
    SecondaryCell,
    SecondaryInformation,
  },
  Container,
  Row,
  Head,
  Cell,
  Body,
};
